<template>
  <InputWithLabel :label="$t('ADVERTISEMENT.CAMPAIGN.STATS.BUILDER.BID_NAMES')">
    <FilterableElSelect
      :value="value"
      :data="bids"
      :multiple-limit="5"
      reserve-keyword
      :placeholder="$t('ADVERTISEMENT.CAMPAIGN.STATS.BUILDER.BID_NAMES')"
      :remote-method="debounceSearch"
      :loading="isBidSearching"
      @input="emitChange"
    >
      <template slot-scope="{ data }">
        <ElOption
          v-for="item in data"
          :key="item.id"
          :label="item.query"
          :value="item.id"
        />
      </template>
    </FilterableElSelect>
  </InputWithLabel>
</template>

<script>
import debounce from 'lodash.debounce';
import FilterableElSelect from './FilterableElSelect';

import { AdInsight } from '@/api/api';
import campaignId from '@/mixins/advertisement/campaignId';
import InputWithLabel from '@@/common/InputWithLabel';

export default {
  name: 'CampaignBidsFilter',
  components: {
    FilterableElSelect,
    InputWithLabel,
  },
  mixins: [campaignId],
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isBidSearching: false,
      bids: [],
    };
  },
  created() {
    this.getLastBids();
  },
  methods: {
    getLastBids() {
      this.searchBid();
    },
    searchBidDebounced: debounce(function(bid) {
      this.searchBid(bid).then(() => {
        this.isBidSearching = false;
      });
    }, 1000),
    debounceSearch(bid) {
      this.isBidSearching = true;
      this.searchBidDebounced(bid);
    },
    searchBid(bid) {
      return AdInsight.searchQuery({ query: bid, itemId: this.campaignId })
        .then(({ body }) => {
          this.bids = body;
        })
        .catch(({ body: { message = '' } }) => {
          if (message) {
            this.$message.error(message);
          }
        });
    },
    emitChange(value) {
      this.$emit('input', value);
    },
  },
};
</script>
